import React from 'react';
import { TextInput, SelectInput, required, Create, Edit } from 'react-admin';
import { FormSpy } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import SimpleFormWithSave from '../../../core/components/form/SimpleFormWithSave';
import { validatePhoneNumber } from '../../../core/utils/index';
import { fieldLengthValidator } from '../../../core/utils/index';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

const userPhoneExtensionMaxLength = 15;

const UserPhoneFormFields = ({ operation, userphonetypes }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <SelectInput
        disabled={operation !== 'Create'}
        optionText="name"
        label="Phone Type"
        source="phoneTypeId"
        validate={[required()]}
        choices={userphonetypes}
        variant="standard"
      />
    </Grid>
    <Grid item xs={12} sm={12} md={6} lg={6}>
      <TextInput
        label="Phone Number"
        source="phoneNumber"
        validate={[required(), validatePhoneNumber]}
        options={{ autoComplete: 'off' }}
        variant="standard"
      />
    </Grid>
    <Grid item xs={12} sm={12} md={6} lg={6}>
      <TextInput
        label="Extension"
        source="extension"
        validate={fieldLengthValidator(userPhoneExtensionMaxLength)}
        options={{ autoComplete: 'off' }}
        variant="standard"
      />
    </Grid>
  </Grid>
);

//

const getAvailablePhoneTypes = (
  userphonetypes,
  userphones,
  currentUserPhone
) => {
  const existingPhoneTypes = userphones.list.ids
    .filter(id => id !== currentUserPhone)
    .map(id => userphones.data[id].phoneTypeId);
  const availableIds = userphonetypes.list.ids.filter(
    id => !existingPhoneTypes.includes(id)
  );
  return availableIds.map(id => {
    return userphonetypes.data[id];
  });
};

const UserPhoneForm = props => {
  const {
    formRef,
    handleSubmit,
    operation,
    showDialog,
    handleDialogToggle,
    crudGetManyReference,
    fetchEnd,
    fetchStart,
    crudGetList,
    loaded,
    currentSort,
    setSort,
    classes,
    userphones,
    userphonetypes,
    popupTitle,
    okButtonLabel,
    ...operationProps
  } = props;

  if (operation === 'Create') {
    return (
      <Create {...operationProps} className={classes.fullWidth}>
        <SimpleFormWithSave
          onSave={handleSubmit}
          toolbar={null}
          // We override the redux-form name to avoid collision with the react-admin main form
          resource="userphones"
          variant="standard"
          margin="normal"
        >
          <FormSpy>
            {props => {
              formRef.current = props.form;
              return (
                <UserPhoneFormFields
                  operation={operation}
                  userphonetypes={getAvailablePhoneTypes(
                    userphonetypes,
                    userphones
                  )}
                />
              );
            }}
          </FormSpy>
        </SimpleFormWithSave>
      </Create>
    );
  } else {
    return (
      <Edit {...operationProps} className={classes.fullWidth}>
        <SimpleFormWithSave
          onSave={handleSubmit}
          toolbar={null}
          // We override the redux-form name to avoid collision with the react-admin main form
          resource="userphones"
          variant="standard"
          margin="normal"
        >
          <FormSpy>
            {props => {
              formRef.current = props.form;
              return (
                <UserPhoneFormFields
                  operation={operation}
                  userphonetypes={getAvailablePhoneTypes(
                    userphonetypes,
                    userphones,
                    operationProps.id
                  )}
                />
              );
            }}
          </FormSpy>
        </SimpleFormWithSave>
      </Edit>
    );
  }
};

export default withStyles(styles)(UserPhoneForm);
